import Layout from "../../components/Layout";

export function Page() {
  // const images = [image1, image2 ];
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="acticle-title" >
            Технические решения для Обрабатывающей промышленности
          </h1>

          <p>
            Современные тенденции и пути развития систем автоматизации технологических процессов в российской обрабатывающей промышленности связаны с цифровизацией, повышением производительности, снижением затрат и улучшением качества продукции.  </p>
          <p>
            SCADA-системы играют ключевую роль в современных тенденциях автоматизации обрабатывающей промышленности России. Они обеспечивают сбор данных, мониторинг и управление процессами в реальном времени. Компании обрабатывающей промышленности в России активно внедряют SCADA-системы для модернизации своих производственных процессов и повышения конкурентоспособности на мировом рынке.    </p>
          <p>
            Рассмотрим примеры решения по автоматизации с применением <b>SCADA NPT Compact</b>:
          </p>

          <ul className="mb-4 description__list">

            <li className="mb-1 description__number-li"  >
              <b>Цифровизация и Industry 4.0</b>
              <ul>
                <li><b>Тенденция:</b> Внедрение технологий Industry 4.0, включая цифровые двойники, интернет вещей (IoT).</li>
                <li>
                  <b>Применение SCADA Compact:</b> SCADA NPT Compact может собирать данные с оборудования и датчиков, которые используются для создания цифровых двойников и моделирования производственных процессов. Это позволяет оптимизировать производство и прогнозировать возможные сбои.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Автоматизация  производственных линий</b>
              <ul>
                <li><b>Тенденция:</b> Внедрение полностью автоматизированных производственных линий с минимальным участием человека.</li>
                <li><b>Применение SCADA Compact:</b> SCADA NPT Compact контроль за работой оборудования, таких как конвейеры, роботы и станки, в режиме реального времени. Она также позволяет автоматически регулировать параметры работы для повышения производительности.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Прогнозирующее техническое обслуживание (Predictive Maintenance)</b>
              <ul>
                <li><b>Тенденция:</b> Переход от планового обслуживания к обслуживанию по состоянию оборудования.</li>
                <li>
                  <b>Применение SCADA Compact:</b> SCADA NPT Compact может собирать данные о работе оборудования, которые анализируются для прогнозирования износа и планирования ремонтов.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Повышение энергоэффективности</b>
              <ul>
                <li><b>Тенденция:</b>Оптимизация энергопотребления на объектах добычи.</li>
                <li><b>Применение SCADA Compact:</b> SCADA NPT Compact позволяет контролировать энергопотребление оборудования и автоматически регулировать его работу для снижения затрат на энергию.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Контроль качества продукции</b>
              <ul>
                <li><b>Тенденция:</b>Внедрение систем автоматического контроля качества продукции.</li>
                <li><b>Применение SCADA Compact:</b>SCADA NPT Compact позволяет интегрироваться с системами контроля, такими как видеокамеры и датчики, для мониторинга процесса производства и параметров продукции в реальном времени.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Экологический мониторинг и снижение выбросов</b>
              <ul>
                <li><b>Тенденция:</b>Внедрение систем мониторинга окружающей среды для снижения экологического воздействия.</li>
                <li>
                  <b>Применение SCADA Compact:</b>SCADA NPT Compact может интегрироваться с датчиками контроля выбросов и качества воздуха, что позволяет оперативно выявлять и устранять нарушения.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Кибербезопасность</b>
              <ul>
                <li> <b>Тенденция:</b>Усиление защиты автоматизированных систем от кибератак.</li>
                <li> <b>Применение SCADA Compact:</b>SCADA NPT Compact оснащается встроенными средствами кибербезопасности.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Использование больших данных и искусственного интеллекта (ИИ)</b>
              <ul>
                <li> <b>Тенденция:</b>Анализ больших объемов данных для оптимизации процессов добычи и принятия решений.</li>
                <li> <b>Применение SCADA Compact:</b> SCADA NPT Compact может собрать данные, которые затем анализируются для прогнозирования производства, оптимизации режимов работы и снижения затрат.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Развитие облачных технологий</b>
              <ul>
                <li> <b>Тенденция:</b> Использование облачных платформ для хранения и обработки данных.</li>
                <li> <b>Применение SCADA Compact:</b> SCADA NPT Compact может интегрироваться с облачными платформами и MES системами, что позволяет централизованно управлять данными и активами.</li>
              </ul>
            </li>
          </ul>

        </div>
      </div>
    </Layout>
  );
}
export const meta = {
  title: 'Технические решения для Обрабатывающей промышленности',
  // description: '
}
//export const doNotPrerender = false;